import React from 'react';

export const getStatusClassAndText = (status) => {
  if (typeof status === 'string' && status.startsWith('PROGRESS:')) {
    const percent = status.split(':')[1];
    return { class: 'bg-progress', text: 'COMPLETED', progress: percent };
  }
  switch (status) {
    case 'WAITING':
      return { class: 'bg-waiting', text: 'WAITING' };
    case 'RUNNING':
      return { class: 'bg-warning', text: 'RUNNING' };
    case 'COMPLETED':
      return { class: 'bg-primary', text: 'COMPLETED' };
    case 'FAILED':
      return { class: 'bg-danger', text: 'FAILED' };
    case 'INAPPLICABLE':
      return { class: 'bg-warning-badge', text: 'DISABLED' };
    case 'MAPPED':
      return { class: 'bg-primary', text: 'MAPPED' };
    default:
      return { class: 'bg-secondary', text: 'NOT BEGUN' };
  }
};

// .bg-progress reads --status-progress for the width of the fill.
const progressProps = (statusInfo) =>
  statusInfo.progress
    ? { style: { '--status-progress': `${statusInfo.progress}%` } }
    : {};

const renderBadge = (status, sizeClass, fullWidth) => {
  const statusInfo = getStatusClassAndText(status);
  return (
    <span
      className={`badge ${sizeClass} ${fullWidth ? 'w-100' : ''} ${statusInfo.class}`}
      {...progressProps(statusInfo)}
    >
      {statusInfo.progress && (
        <span className="fw-bold">{statusInfo.progress}%</span>
      )}
      {statusInfo.text}
    </span>
  );
};

export const StatusBadge = ({ status, fullWidth = false }) =>
  renderBadge(status, '', fullWidth);

export const StatusBadgeSm = ({ status, fullWidth = false }) =>
  renderBadge(status, 'badge-sm', fullWidth);

export const StatusBadgeXSm = ({ status, fullWidth = false }) =>
  renderBadge(status, 'badge-xsm', fullWidth);